// extracted by mini-css-extract-plugin
export default {"dropdown":"SovViewSwitcher_dropdown__J6VOy","value":"SovViewSwitcher_value__6CFxp","item":"SovViewSwitcher_item__5bw0O","description":"SovViewSwitcher_description__9ETEb"};